import { render, staticRenderFns } from "./assinaTermo.vue?vue&type=template&id=28d2269e&"
import script from "./assinaTermo.vue?vue&type=script&lang=js&"
export * from "./assinaTermo.vue?vue&type=script&lang=js&"
import style0 from "./assinaTermo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports